export default "__VITE_ASSET__CByfjdTg__"